import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { isObjEmpty, isNull } from "../../components/common/Common";

import "../../css/style.css";

import userIcon from "../../img/icon/icon-stroke-user.svg";
import passIcon from "../../img/icon/icon-stroke-lock.svg";

const Login = () => {
  const navigate = useNavigate();

  const refID = useRef();
  const refPwd = useRef();
  const refLogin = useRef();

  if (isNull(localStorage.getItem("userLoginState"))) {
    localStorage.setItem("userLoginState", 0);
  }
  if (isNull(localStorage.getItem("autoLogin"))) {
    localStorage.setItem("autoLogin", 0);
  }
  const loginState = Number(localStorage.getItem("userLoginState"));
  const autoLogin = Number(localStorage.getItem("autoLogin"));
  const [varLoginInfo, setLoginInfo] = useState({
    login_id: "",
    login_pwd: "",
    auto_login: autoLogin,
  });

  //입력값 저장
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if (name === "login_id") {
      const svalue = value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, "");
      setLoginInfo({ ...varLoginInfo, [name]: svalue });
    } else {
      setLoginInfo({ ...varLoginInfo, [name]: value });
    }
  };
  //자동로그인
  const onSetAutoLoginHandler = (e) => {
    const bmode = Number(e.currentTarget.checked);
    setLoginInfo({ ...varLoginInfo, auto_login: bmode });
    localStorage.setItem("autoLogin", bmode);
  };
  //로그인 작업 수행
  const onLoginProgressHandler = (e) => {
    if (varLoginInfo.login_id === "") {
      alert("로그인하기 위한 아이디를 먼저 입력하세요.");
      return false;
    }
    if (varLoginInfo.login_pwd === "") {
      alert("로그인하기 위한 비밀번호를 먼저 입력하세요.");
      return false;
    }
    const mem_device = localStorage.getItem("fcm_token");
    const sendData = {
      login_mode: 1,
      auto_login: 0,
      loginInfo: varLoginInfo,
      mem_device: mem_device,
    };
    loginProgressing(sendData);
  };

  const loginProgressing = async (sendData) => {
    console.log(sendData);
    await axios
      .post(`${process.env.REACT_APP_HOST}/_login_progress`, sendData)
      .then((res) => {
        const datas = res.data;
        console.log(datas);
        if (datas.retvalue === 1) {
          const members = datas.results[0];
          //로그인 절차
          localStorage.setItem("mem_idx", members.mem_idx);
          localStorage.setItem("mem_id", members.mem_id);
          localStorage.setItem("mem_name", members.mem_name);
          localStorage.setItem("mem_mobile", members.mem_mobile);
          localStorage.setItem("mem_mode", members.mem_mode);
          localStorage.setItem("mem_carnumb", members.dr_carnumb);
          localStorage.setItem("userLoginState", 1);
          //페이지이동
          navigate(`/Main`);
        } else {
          refPwd.current.value = "";
          refID.current.value = "";
          refID.current.focus();
          alert(datas.message);
        }
      });
  };

  //FCM TOKEN 메모리에 저장
  //실행함수
  const eventFromAndroid = async (e) => {
    console.log(e.detail.token);
    //alert(e.detail.token);
    localStorage.setItem("fcm_token", e.detail.token);
  };

  //최초실행부
  useEffect(() => {
    //네이티브에 기기코드 요청
    const mobileType = navigator.userAgent.toLowerCase();
    if (mobileType.indexOf("android") > -1) {
      if (window.betterLogis) {
        //안드로이드로부터 받기
        window.addEventListener("onFcmInfoSuccess", eventFromAndroid);
        //안드로이드로 보내기
        window.betterLogis.getFcmInfo();
      }
    } else if (
      mobileType.indexOf("iphone") > -1 ||
      mobileType.indexOf("ipad") > -1 ||
      mobileType.indexOf("ipod") > -1
    ) {
      if (window.webkit) {
        alert("ios:" + window.webkit);
        window.webkit.messageHandlers.getFcmInfo.postMessage("");
      }
    }

    refID.current.focus();
    //auto_login---------
    if (autoLogin === 1 && loginState === 0) {
      if (!isNull(localStorage.getItem("mem_idx"))) {
        const idx = localStorage.getItem("mem_idx");
        const mem_device = localStorage.getItem("fcm_token");
        if (idx > 0) {
          const sendData = {
            login_mode: 1,
            auto_login: 1,
            mem_idx: idx,
            mem_device: mem_device,
          };
          loginProgressing(sendData);
        }
      }
    }

    return () => {
      if (window.betterLogis) {
        window.removeEventListener("onFcmInfoSuccess", eventFromAndroid);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //키보드
  const onKeyPressHandler = (e, ino) => {
    if (e.key === "Enter") {
      if (ino === 0) {
        refPwd.current.focus();
      } else {
        refLogin.current.click();
      }
    }
  };

  return isObjEmpty(varLoginInfo) ? null : (
    <div className="vh-container">
      <div className="vh-content">
        <div className="sign-content-wrap">
          <div className="sign-form-wrap">
            <Link to="/Main">
              <div className="logo mb35">더나은물류</div>
            </Link>
            <div className="sign-form-group mb10">
              <div className="sign-field-group">
                <div className="sign-icon">
                  <img src={userIcon} alt="" />
                </div>
                <input
                  type="text"
                  className="form-control"
                  ref={refID}
                  name="login_id"
                  value={varLoginInfo.login_id}
                  placeholder="아이디를 입력하세요"
                  onKeyPress={(e) => onKeyPressHandler(e, 0)}
                  onChange={(e) => onChangeInputHandler(e)}
                />
              </div>
            </div>
            <div className="sign-form-group mb10">
              <div className="sign-field-group">
                <div className="sign-icon">
                  <img src={passIcon} alt="" />
                </div>
                <input
                  type="password"
                  className="form-control"
                  ref={refPwd}
                  name="login_pwd"
                  value={varLoginInfo.login_pwd}
                  placeholder="비밀번호를 입력하세요"
                  onKeyPress={(e) => onKeyPressHandler(e, 1)}
                  onChange={(e) => onChangeInputHandler(e)}
                />
              </div>
            </div>
            <div className="sign-form-group mb50">
              <div className="sign-auto">
                <div className="checkbox">
                  <input
                    type="checkbox"
                    name="auto_login"
                    id="auto_login"
                    defaultChecked={varLoginInfo.auto_login}
                    onChange={(e) => onSetAutoLoginHandler(e)}
                  />
                  <label htmlFor="auto_login">자동 로그인</label>
                </div>
              </div>
            </div>
            <div className="sign-find mb30">
              <Link to="/FindID">아이디 찾기</Link>
              <Link to="/FindPWD">비밀번호 찾기</Link>
            </div>
            <div className="form-contoller flex-vertical">
              <button
                ref={refLogin}
                className="form-contoller-btn mb10"
                onClick={(e) => onLoginProgressHandler(e)}
              >
                로그인
              </button>
              <div className="form-contoller-desc">
                계정이 없으신 경우 관리자에게 문의 바랍니다.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
